<script lang="ts">
	import { Verbiage, t } from '@infinitro/content';
	import { parseInlineBoldSegments } from '../parse-inline-bold-segments';
	import { isSupportChatMediaUrl } from '../utils/support-chat-media-url';

	export let text = '';

	$: mediaUrl = isSupportChatMediaUrl(text) ? text.trim() : null;
	$: plainText = mediaUrl ? '' : text;
</script>

{#if mediaUrl}
	<img class="bubble-media" src={mediaUrl} alt={$t(Verbiage.message_icon_alt, 'alts')} />
{:else}
	{#each parseInlineBoldSegments(plainText) as seg, i (i)}
		{#if seg.bold}
			<strong class="bubble-inline-strong">{seg.text}</strong>
		{:else}
			{seg.text}
		{/if}
	{/each}
{/if}

<style>
	.bubble-inline-strong {
		font-weight: 600;
	}

	.bubble-media {
		display: block;
		max-height: 12rem;
		max-width: 100%;
		border-radius: 12px;
		-o-object-fit: contain;
		   object-fit: contain;
}
</style>
